export const getDefaultOptions = () => ({
  headers: { "Content-Type": "application/json" },
});

export const throwExceptionErrors = (response) => {
  if (!response || !response.code) return;
  const error = new Error(response.code);
  error.code = response.code || "";
  error.values = response.values || [];
  throw error;
};

export const deserializeJsonResponse = async (response, defaultReturn = []) => {
  const text = await response.text();
  var deserializedResponse = null;
  try {
    deserializedResponse = text.length ? JSON.parse(text) : defaultReturn;
  } catch (e) {}
  return deserializedResponse;
};
export const getErrorMessageFromResponseBody = (responseBody) => {
  if (responseBody && responseBody.Errors && responseBody.Errors.length > 0)
    return responseBody.Errors[0].Message;
  else {
    return "Something went wrong on the server";
  }
};
export const isExceptionInResponseBody = (responseBody) => {
  if (responseBody && responseBody.ErrorCount > 0) return true;
  else return false;
};
